import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import HotRankingSection from "@/pages/home/components/HotRankingSection";
import TopicFeedSection from "@/pages/home/components/TopicFeedSection";
import CategorySection from "@/pages/home/components/CategorySection";
import DeepDiveSection from "@/pages/home/components/DeepDiveSection";
import FaqSection from "@/pages/home/components/FaqSection";
import VoiceSection from "@/pages/home/components/VoiceSection";
import ContactSection from "@/pages/home/components/ContactSection";
import { faqs } from "@/mocks/faqs";
import { useSeo } from "@/hooks/useSeo";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "网曝吃瓜",
    alternateName: "网曝吃瓜 · 热点围观现场",
    description:
      "聚合全网热门吃瓜话题与热搜榜单，实时围观当下最热的讨论现场。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "网曝吃瓜",
    description: "全网热点话题、热搜与围观讨论的内容聚合站。",
    email: "editor@wnchigua.com",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "网曝吃瓜 - 全网热点话题与热搜围观现场实时看",
    description:
      "网曝吃瓜聚合全网热门吃瓜话题与热搜榜单，实时围观当下最热讨论现场。从热搜榜到深度讨论，带你看懂热度中心，参与互动，一起围观。",
    keywords: "网曝吃瓜,吃瓜话题,吃瓜热搜,吃瓜讨论,围观现场,话题热度",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRankingSection />
        <TopicFeedSection />
        <CategorySection />
        <DeepDiveSection />
        <FaqSection />
        <VoiceSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}